module.exports = __webpack_public_path__ + "img/wizard-close.441258e7.svg";